import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Hero } from './components/Hero';
import { LogoVariations } from './components/LogoVariations';
import { ColorPalette } from './components/ColorPalette';
import { DesignSystem } from './components/DesignSystem';
import { Pricing } from './components/Pricing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Menu, X } from 'lucide-react';
export function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-white text-navy selection:bg-coral selection:text-white" data-id="element-0">
      {/* Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-coral origin-left z-50" style={{
      scaleX
    }} data-id="element-1" />

      {/* Navigation */}
      <nav className={`fixed top-0 w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md border-b border-navy/10 py-4' : 'bg-transparent py-6'}`} data-id="element-2">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-3">
          <a href="#" className="flex items-center gap-2 group" data-id="element-4">
            <div className="w-6 h-6 bg-navy group-hover:bg-coral transition-colors duration-300 rotate-45" data-id="element-5" />
            <span className="font-bold tracking-tighter text-xl" data-id="element-6">
              COFFRETRESOR
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8 font-mono text-sm tracking-widest" data-id="element-7">
            <a href="#work" className="hover:text-coral transition-colors" data-id="element-8">
              WORK
            </a>
            <a href="#system" className="hover:text-coral transition-colors" data-id="element-9">
              SYSTEM
            </a>
            <a href="#pricing" className="hover:text-coral transition-colors" data-id="element-10">
              PRICING
            </a>
            <a href="#contact" className="px-6 py-2 border-2 border-navy hover:bg-navy hover:text-white transition-colors" data-id="element-11">
              CONTACT
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-12">
            {isMenuOpen ? <X data-id="element-13" /> : <Menu data-id="element-14" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="fixed inset-0 z-30 bg-white pt-24 px-6 md:hidden" data-id="element-15">
          <div className="flex flex-col gap-8 text-2xl font-bold" data-id="element-16">
            <a href="#work" onClick={() => setIsMenuOpen(false)} data-id="element-17">
              WORK
            </a>
            <a href="#system" onClick={() => setIsMenuOpen(false)} data-id="element-18">
              SYSTEM
            </a>
            <a href="#pricing" onClick={() => setIsMenuOpen(false)} data-id="element-19">
              PRICING
            </a>
            <a href="#contact" onClick={() => setIsMenuOpen(false)} className="text-coral" data-id="element-20">
              CONTACT
            </a>
          </div>
        </motion.div>}

      <main data-id="element-21">
        <Hero data-id="element-22" />
        <LogoVariations data-id="element-23" />
        <ColorPalette data-id="element-24" />
        <DesignSystem data-id="element-25" />
        <Pricing data-id="element-26" />
        <Contact data-id="element-27" />
      </main>

      <Footer data-id="element-28" />
    </div>;
}